import React, { useEffect, useRef, useState } from "react";
import vAdminformat from "../../adminFormat";


import config from '../../config';
import axios from "axios";
import { headers } from "../../token";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import validateError from "../../ValidateError";
import STLViewer from "../Canvas/STLViewer";
import SimpleSTLViewer from "../Canvas/SimpleStlViews";
import ColorBox from '../ColorBox';
import STLViewerQuot from "../Canvas/STLViewerQuot";

const server_backend = config.API_URL;

const JobLiveUpdate = ({ CloseViewJob, JobID, getJobs }) => {



    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [materialList, setMaterialList] = useState([]);

    const [optionJobs, setOptionJob] = useState([]);
    const [showOptions, setShowOptions] = useState(false);
    const [files, setFiles] = useState([]);
    const [statusJob, setStatusJob] = useState([]);
    const [temporalyFile, setTemporalyFile] = useState(null);
    const [AddFiles, setAddFiles] = useState(false);
    const [urlFile, setUrlFile] = useState(null);
    const [STLfileBussiness, setSTLFileBussiness] = useState(null);
    const [jobQty, setJobqty] = useState(1);
    const [fileUploadList, setFileUploadlist] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [fileURL, setFileURL] = useState(null);
    const [isPrivate, setIsPrivate] = useState(false);
    const [currentPrice, setCurrentPrice] = useState(0);
    const [selectedMaterial, setSelectedMaterial] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [isUpdateJob, setIsUpdateJob] = useState(0);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [AliasFileName, setAliasFileName] = useState(null);
    const [ConfUpload, setConfUpload] = useState(false);
    const [currentDencity, setCurrentDencity] = useState(0);
    const [selectedMaterialColor, setSelectedMaterialColor] = useState('#FFFFFF');
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [selectedMaterialName, setSelectedMaterialName] = useState('');
    const [searchTerm, setSearchTerm] = useState(''); //Status to store the search term
    const [filteredFiles, setFilteredFiles] = useState([]); //Status for filtered files
    const [customerFiles, setCustomerFile] = useState([]);
    const [temporaryOrder, setTemporaryOrder] = useState([]);
    const [isInitialized, setIsInitialized] = useState(false);
    const [materialPrice, setMaterialPrice] = useState([]);
    const [getBussinessFiles, setGetBussinessFiles] = useState([]);

    const CHUNK_SIZE = 10240 * 10240;

    const navigate = useNavigate();

    const [formData, setFormData] = useState({

    });

    useEffect(() => {
        const storedName = localStorage.getItem('yourName');
        if (storedName) {
            setUsername(storedName);
        }
    }, []);

    useEffect(() => {
        const getCurrentJob = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/jobs/manual/select?id=${JobID}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT;
                    //console.log({ data: data });
                    setUrlFile(`${server_backend}/${data.files_path_file}`)
                    setFormData({
                        ...data,
                        mat_id: data.mat_ID,
                        ordj_id: data.ordj_ID,
                        file_id: data.file_ID,
                        est_id: data.est_ID,
                        job_id: JobID,
                        discount_ptg: parseFloat(data.discount_ptg).toFixed(2)
                    });
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)

            }
        }
        getCurrentJob();
    }, []);

    useEffect(() => {
        const getCurrentOrder = async () => {

            try {
                const response = await axios.get(`${server_backend}/orders/select?id=${formData.ord_ID}`, headers);
                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT;

                    setFiles(data.jobs);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getCurrentOrder();
    }, [formData]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const getMaterial = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMaterialList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getMaterial();
    }, []);

    useEffect(() => {
        const getMaterialPrice = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/types/list`, headers);
                //console.log({ eo: response.data });

                if (response.data.RES_CODE === "00") {
                    setMaterialPrice(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getMaterialPrice();
    }, []);


    useEffect(() => {
        const getOptionJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/options_job_value/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setOptionJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getOptionJob();
    }, []);

    //handles the decrease in quantity
    const handleDecreaseQuantity = () => {
        setJobqty(Math.max(jobQty > 1 ? jobQty - 1 : 1)
        );
    };

    //handle the quantity increase
    const handleIncreaseQuantity = () => {
        setJobqty(jobQty ? jobQty + 1 : 1
        );
    };

    const handleDecreaseWaxQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            wax_qty: Math.max(prevState.wax_qty > 1 ? prevState.wax_qty - 1 : 0)
        }));
    };

    const handleIncreaseWaxQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            wax_qty: prevState.wax_qty ? prevState.wax_qty + 1 : 1
        }));
    };

    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);
                //console.log({ Hello: response.data });
                if (response.data.RES_CODE === "00") {
                    setStatusJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusJob();
    }, []);

    const handleUpdate = async () => {
console.log(formData);
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to save the changes?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel'
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/jobs/manual/update`, {
                        ...formData,
                        nofile: !formData.ordj_id ? 1 : 0
                    }, headers);
                    //console.log(response.data);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        CloseViewJob();
                        getJobs()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Metal already exists, please try another name',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            }
        });


    };


    const selectFiles = () => {

        if (temporalyFile) {

            setUrlFile(`${server_backend}/${temporalyFile.files_path_file}`)
            setFormData({
                ...formData,
                mat_id: temporalyFile.mat_ID,
                files_name: temporalyFile.files_name,
                file_id: temporalyFile.file_ID,
                ordj_id: temporalyFile.ordj_ID
            })
        }

    }

    const calculatePrice = (formula, formDataWeight, materialPrice) => {
        //Console.log ({Formula: Formula, FormDataWeight: FormDataWeight, MaterialPrice: MaterialPrice});


        if (!formula || formula.trim() === '') {
            return null;
        }

        let processedFormula = formula.replace(/{weight}/g, formDataWeight);

        materialPrice.forEach((material) => {
            const variableName = material.variable.replace(/[{}]/g, '');
            processedFormula = processedFormula.replace(new RegExp(`{${variableName}}`, 'g'), material.lastprice);
        });
        //console.log({ formula: formula, processedFormula: processedFormula })
        try {

            const price = eval(processedFormula);
            return parseFloat(price).toFixed(2);
        } catch (error) {
            console.error("Error calculating price:", error);
            return null;
        }
    };

    const formatStats = (stats) => {
        const formatNumber = (num, decimals) => num.toFixed(decimals);
        //console.log("thi is format stats")
        const volume = formatNumber(stats.volume / 1000, 2);
        const area = formatNumber(stats.area / 100, 2);
        const weight = formatNumber(stats.weight / 1000, 2);

        const dimensions = {
            x: formatNumber(stats.dimensions.x / 10, 2),
            y: formatNumber(stats.dimensions.y / 10, 2),
            z: formatNumber(stats.dimensions.z / 10, 2)
        };

        stats.volume = volume;
        stats.area = area;
        stats.weight = weight;
        stats.file_id = STLfileBussiness.file_ID;
        stats.dimensions = `${dimensions.x} x ${dimensions.y} x ${dimensions.z} cm`;
        //setFormData({volume: ...volume});
        return stats;

        /*return {
            volume: `${volume} cm³`,
            area: `${area} cm²`,
            weight: `${weight} g`,
            dimensions: `${dimensions.x} x ${dimensions.y} x ${dimensions.z} cm`
        }; */
    };

    const clearFileSelection = () => {
        setTemporalyFile(null); //Clean temporary file
        setUrlFile(null); //Clean URL
        setFormData({
            ...formData,
            files_name: null,
            file_id: null,
            ordj_id: null,
        });
    };

    const handleStatsUpdate = (stats) => {
        const formattedStats = formatStats(stats);
        //console.log(stats)
        setFormData(formattedStats);
    };

    const handleMaterialSelect = (material) => {
        setSelectedMaterial(material);
        setFormData({ ...formData, mat_id: material.mat_ID });
        setShowDropdown(false);
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        //setSTLFileBussiness(selectedFile);
        const files = Array.from(event.target.files);
        setSelectedFiles(files);

        //const url = URL.createObjectURL(selectedFile);
        //setFileURL(url);
    };

    const handleFileSelect = (File) => {
        //console.log({ File: File })
        setSTLFileBussiness(File);
        setFileURL(File.path_File);
        setIsDropdownVisible(false);
    };

    useEffect(() => {
        const getBussinessLibrary = async () => {

            try {
                const response = await axios.get(`${server_backend}/files/private/list?user_transaction=${username}`, headers);
                if (response.data.RES_CODE === "00") {

                    setGetBussinessFiles(response.data.RES_RESULT.sort((a, b) => {

                        return b.file_ID - a.file_ID;


                    }));
                }
            } catch (error) {
                console.log(error)
            }
        }
        getBussinessLibrary();
    }, []);


    const getBussinessLibrary = async () => {

        try {
            const response = await axios.get(`${server_backend}/files/private/list?user_transaction=${username}`, headers);
            if (response.data.RES_CODE === "00") {

                setGetBussinessFiles(response.data.RES_RESULT.sort((a, b) => {

                    return b.file_ID - a.file_ID;


                }));
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {

        const selectedMaterial = materialList[0];

        if (selectedMaterial) {
            setSelectedMaterial(selectedMaterial);
            setSelectedMaterialColor(selectedMaterial.color);
        }
    }, [STLfileBussiness, !isUpdateJob]);

    useEffect(() => {
        if (selectedMaterial) {

            const vw = formData.weight * selectedMaterial.density;
            const price = calculatePrice(selectedMaterial.formula, vw, materialPrice);
            if (isUpdateJob === 0) {
                setCurrentPrice(price);
            }
        }
    }, [selectedMaterial, formData.weight, !isUpdateJob]);

    /* useEffect(() => {
         if (isInitialized && selectedMaterial) {
             const vw = formData.weight *selectedMaterial.density;
             const price = calculatePrice(selectedMaterial.formula, vw, materialPrice);
             if (isUpdateJob === 0) {
                 setCurrentPrice(price);
             }
         }
     }, [formData, materialPrice, selectedMaterial, isInitialized, !isUpdateJob]); */
    //end

    //These two hooks are used to correctly select the first material once the corresponding variables have been updated.
    useEffect(() => {
        if (materialList && materialList.length > 0 && formData.mat_id && !isInitialized) {
            const selectedMaterial = materialList.find(material => material.mat_ID === formData.mat_id);

            if (selectedMaterial) {
                handleMaterialSelect(selectedMaterial);
                setSelectedMaterialColor(selectedMaterial.color);
                setCurrentDencity(selectedMaterial.density);

                setIsInitialized(false);
            }
        }
    }, [materialList, formData.mat_id, isInitialized, jobQty, !isUpdateJob]);

    //Filter files when changing the search term or file list
    useEffect(() => {
        if (getBussinessFiles && getBussinessFiles.length > 0) {
            const filtered = getBussinessFiles.filter(file =>
                file.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredFiles(filtered);
        } else {
            setFilteredFiles([]); //If there are no files, empty list
        }
    }, [searchTerm, getBussinessFiles]);


    const closeModalFile = () => {
        //setSTLFileBussiness(null)
        cleanSTLFiles()
        setFileUploadlist(false)

    }

    function cleanSTLFiles() {
        setSelectedMaterial(null);
        setSTLFileBussiness([]);
        setSelectedFiles([]);
        setFormData((prevState) => ({
            ...prevState,
            qty: 1,
            price: 0,
            mat_id: ''
        }))
        //closeModalFile();
    }



    const openModalFile = () => {

        setIsUpdateJob(0);
        setFileUploadlist(true)

    }

    const handleUploadFileModal = async () => {
        if (selectedFiles.length === 0) return;

        setIsUploading(true); //We show the progress bar
        const file = selectedFiles[0]; //We only upload the first file for now
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
        let fileName = file.name; //Original Name of the Archive

        try {
            //Verify if the file already exists

            try {
                const checkResponse = await axios.get(
                    `${server_backend}/files/private/exists?name=${file.name}`,
                    headers
                );

                if (checkResponse.data.RES_CODE === "00") {
                    //If it exists, add an alias based on the date and time

                    const now = new Date();
                    const year = String(now.getFullYear()).slice(2); //Obtain last 2 digits of the year
                    const month = String(now.getMonth() + 1).padStart(2, '0'); //month with 2 digits
                    const day = String(now.getDate()).padStart(2, '0'); //day with 2 digits
                    const hours = String(now.getHours()).padStart(2, '0'); //hour with 2 digits
                    const minutes = String(now.getMinutes()).padStart(2, '0'); //minutes with 2 digits
                    const seconds = String(now.getSeconds()).padStart(2, '0'); //seconds with 2 digits

                    //format the full date as yyymmddhhmms
                    const formattedDate = `${year}${month}${day}${hours}${minutes}${seconds}`;

                    //Obtain extension and base name of the file
                    const fileExtension = file.name.split('.').pop(); //file extension
                    const fileBaseName = file.name.replace(`.${fileExtension}`, ''); //Name without extension

                    //Create the new file name
                    fileName = `${fileBaseName}_${formattedDate}.${fileExtension}`;



                }
            } catch (error) {
                //console.log(error)
            }


            for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                const start = chunkIndex * CHUNK_SIZE;
                const end = Math.min(start + CHUNK_SIZE, file.size);
                const chunk = file.slice(start, end);

                const formData = new FormData();
                formData.append('chunk', chunk);
                formData.append('chunkIndex', chunkIndex);
                formData.append('totalChunks', totalChunks);
                formData.append('name', fileName); //Use the name with alias if there is conflict
                formData.append('user_transaction', username);
                setAliasFileName(fileName);
                const uploadConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': headers.headers.Authorization,
                    },
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round(
                            ((chunkIndex + 1) / totalChunks) * 100
                        );
                        setUploadProgress(percentCompleted);
                    },
                };

                try {
                    const uploadResponse = await axios.post(
                        `${server_backend}/files/private/insert`,
                        formData,
                        uploadConfig
                    );

                    if (uploadResponse.data.RES_CODE === "00") {
                        setConfUpload(true);
                        setIsUploading(false); //We restart the state
                        setUploadProgress(0);
                        return; //end the function after the successful load
                    }
                } catch (uploadError) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error uploading file',
                        text: 'There was an issue uploading the file.',
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    setIsUploading(false);
                    setUploadProgress(0);
                    return; //We leave in case of error
                }
            }
        } catch (error) {
            console.error('Error checking file existence:', error);
        } finally {
            getBussinessLibrary(); //Update the library after loading
        }

        setIsUploading(false); //We hide the progress bar
        setUploadProgress(0); //We restart progress after loading
    };

    const handlePriceChange = (e) => {
        const value = e.target.value;

        //Allows only numbers and a decimal point
        const cleanValue = value.replace(/[^0-9.]/g, '');

        //Verify that there is no more than a decimal point
        if ((cleanValue.match(/\./g) || []).length <= 1) {
            //Update the state without even parse to allow the point in real time
            setCurrentPrice(cleanValue);
        }
    };

    const createJobs = () => {

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const newItem = {
                    id: formData.ord_ID,
                    volume: formData.volume,
                    area: formData.area,
                    weight: formData.weight,
                    dimensions: formData.dimensions,
                    job_comment: formData.job_comment,
                    file_id: formData.file_id,
                    mat_id: selectedMaterial.mat_ID,
                    price: currentPrice,
                    qty: jobQty,
                    mount: currentPrice,
                    filename: STLfileBussiness.name,
                    materialname: selectedMaterial.name,
                    discount: formData.discount,
                    file_private: isPrivate,
                    urlfile: fileURL
                };
                //console.log({ Items: newItem });
                try {
                    const response = await axios.post(`${server_backend}/Orders/jobs/insert`, newItem, headers);
                    console.log(response.data);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Created Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });

                        cleanSTLFiles()
                        //reloadOrderSelected()
                        setFileUploadlist(false)
                        setLoading(false);

                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'An error occurred, please try again.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    console.log(error)
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    //reloadOrderSelected() //update Order select
                }
            }
        }
        )

    };

    return (


        <div className="">
            <div className="card-header">
                <div className="d-flex justify-content-end">
                    <div className="flex-grow-1 d-flex align-items-center justify-content-between">
                        {/*Job Number text */}
                        <h5 className="mb-0">
                            Job Number: <Link>{formData.job_number}</Link>
                        </h5>

                        {/*Buttons aligned to the right */}
                        <div className="hstack gap-2">
                            {/*Button to rule out changes */}
                            <Link
                                className="btn btn-danger"
                                onClick={() => {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Alert',
                                        text: "Are you sure you want to discard these changes?",
                                        showCancelButton: true,
                                        confirmButtonText: 'Accept',
                                        cancelButtonText: "Cancel"
                                    }).then(async (result) => {
                                        if (result.isConfirmed) {
                                            CloseViewJob();
                                        }
                                    });
                                }}
                            >
                                Discard Changes
                            </Link>

                            {/*Save change button */}
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleUpdate}
                            >
                                <i className="ri-save-line align-bottom me-1"></i> Save
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <div className="col-12 card card-body">
                <form >
                    <div className="row">
                        <h5>Order Info</h5><br /><br />
                        <div className="col-4">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Order No. </label>
                                <span class="text-danger" style={{ marginLeft: "5px" }}>*</span>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        name="name"
                                        value={formData.ord_ID}
                                        required
                                        disabled
                                    />

                                </div>
                            </div>

                        </div>

                        <div className="col-md-4">
                            <div className="mb-3">
                                <label htmlFor="phone" className="form-label">Customer ID</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    value={formData.cust_ID}

                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="mb-3">
                                <label htmlFor="phone" className="form-label">Customer Name</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    disabled
                                    id="phone"
                                    name="phone"
                                    value={formData.fullname}

                                />
                            </div>
                        </div>

                        <h5 style={{ paddingBlock: "9px" }}>Files</h5>
                        <div className="col-12 mb-3">
                            <div className="row">
                                <div className="col-6">
                                    <div>
                                        <div className="mb-3">
                                            <label htmlFor="name" className="form-label">Files</label>
                                            <div className="input-group">
                                                {/*Icon to select file */}
                                                <span className="input-group-text th-hover" onClick={() => setAddFiles(true)}>
                                                    <i className="ri-file-edit-line"></i>
                                                </span>
                                                {/*Icon for cleaning selection */}
                                                <span className="input-group-text th-hover" onClick={() => clearFileSelection()}>
                                                    <i className="ri-delete-bin-5-fill text-danger"></i>
                                                </span>
                                                {/*Input to show file name */}
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    name="name"
                                                    value={formData.files_name || ""}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Metal Type</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.mat_id || ""}
                                                onChange={(e) => setFormData({ ...formData, mat_id: e.target.value })}
                                            >
                                                <option value="">Select the option</option>
                                                {materialList.map((OptionJ) => (
                                                    <option key={OptionJ.mat_ID} value={OptionJ.mat_ID}>
                                                        {OptionJ.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div>
                                        <div style={{ height: "34vh", width: "100%" }}>
                                            <SimpleSTLViewer url={urlFile} />
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label htmlFor="comment" className="form-label">Description</label>
                                <textarea
                                    className="form-control"
                                    id="comment"
                                    name="comment"
                                    value={formData.comment}
                                    onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
                                ></textarea>
                            </div>
                        </div>

                        <div className="col-3 ">
                            <label htmlFor="quantityInput" className="form-label">Injection Wax Quantity</label>
                            <div className="input-step d-flex align-items-center w-100">
                                <button type="button" className="minus btn btn-light" onClick={() => handleDecreaseWaxQuantity()}>–</button>
                                <input
                                    type="number"
                                    className="form-control text-center mx-2 product-quantity w-100"
                                    value={formData.wax_qty}
                                    min="0"
                                    max="100"
                                />

                                <button type="button" className="plus btn btn-light" onClick={() => handleIncreaseWaxQuantity()}>+</button>
                            </div>
                        </div>

                        <div className="col-9">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Quantity or Designate </label>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        name="name"
                                        value={formData.designate}
                                        onChange={(e) => setFormData({ ...formData, designate: e.target.value })}
                                        required
                                    />

                                </div>
                            </div>

                        </div>

                        <h5 style={{ paddingBlock: "18px" }}>Additional Information</h5>
                        <div className="row">


                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">3D Print</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="optjc_id"
                                        value={formData.print_type}
                                        onChange={(e) => setFormData({ ...formData, print_type: e.target.value })}
                                    ><option>Select the option</option>
                                        {[...new Map(
                                            optionJobs
                                                .filter(option => option.optjc_ID === 1)
                                                .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate
                                        ).values()].map(uniqueOption => (
                                            <option value={uniqueOption.optjv_ID}>
                                                {uniqueOption.name}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">Print Charge (£)</label>
                                    <div className="position-relative">
                                        {/*Input principal */}
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter amount or select an option"
                                            value={formData.print_charge || ""}
                                            onKeyDown={() => setShowOptions(false)}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    print_charge: e.target.value,
                                                });
                                            }}
                                            onFocus={() => setShowOptions(true)}
                                        />

                                        {/*List of options (buttons) */}
                                        {showOptions && (
                                            <div
                                                className="dropdown-menu show position-absolute w-100 mt-1"
                                                style={{
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                    zIndex: 1050,
                                                }}
                                            >
                                                {[...new Map(
                                                    optionJobs
                                                        .filter(option => option.optjc_ID === 2)
                                                        .map(option => [option.name, option]) //Avoid duplicates
                                                ).values()].map((uniqueOption) => (
                                                    <button

                                                        className="dropdown-item"
                                                        type="button"
                                                        onClick={() => {
                                                            setFormData({
                                                                ...formData,
                                                                print_charge: uniqueOption.value,
                                                            });
                                                            setShowOptions(false);
                                                        }}
                                                    >
                                                        {uniqueOption.name}
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">Print Discount (%)</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="optjc_id"
                                        value={formData.discount_ptg}
                                        onChange={(e) => setFormData({ ...formData, discount_ptg: e.target.value })}
                                    ><option>Select the option</option>
                                        {[...new Map(
                                            optionJobs
                                                .filter(option => option.optjc_ID === 3)
                                                .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate
                                        ).values()].map(uniqueOption => (
                                            <option value={parseFloat(uniqueOption.value).toFixed(2)}>
                                                {uniqueOption.name}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">Moulding</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="optjc_id"
                                        value={formData.moulding}
                                        onChange={(e) => setFormData({ ...formData, moulding: e.target.value })}
                                    ><option>Select the option</option>
                                        {[...new Map(
                                            optionJobs
                                                .filter(option => option.optjc_ID === 4)
                                                .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate
                                        ).values()].map(uniqueOption => (
                                            <option value={uniqueOption.optjv_ID}>
                                                {uniqueOption.name}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>


                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">Mould Only</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="optjc_id"
                                        value={formData.mould_only}
                                        onChange={(e) => setFormData({ ...formData, mould_only: e.target.value })}
                                    ><option>Select the option</option>
                                        {[...new Map(
                                            optionJobs
                                                .filter(option => option.optjc_ID === 5)
                                                .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate
                                        ).values()].map(uniqueOption => (
                                            <option value={uniqueOption.optjv_ID}>
                                                {uniqueOption.name}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">Expected Cast Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="name"
                                        name="name"
                                        value={formData.date_estimated}
                                        onChange={(e) => setFormData({ ...formData, date_estimated: e.target.value })}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">


                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">Sprue Master</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="optjc_id"
                                        value={formData.sprue_master}
                                        onChange={(e) => {
                                            if (e.target.value == 0) {
                                                setFormData({ ...formData,sprue_master: e.target.value, sprue_material: '', sprue_feed: '' });
                                            } else {
                                                setFormData({ ...formData, sprue_master: e.target.value });
                                            }
                                        }}
                                    ><option value={0}>Select the option</option>
                                        {[...new Map(
                                            optionJobs
                                                .filter(option => option.optjc_ID === 6)
                                                .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate
                                        ).values()].map(uniqueOption => (
                                            <option value={uniqueOption.value}>
                                                {uniqueOption.name}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">Sprue Material</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="optjc_id"
                                        value={formData.sprue_material}
                                        onChange={(e) => setFormData({ ...formData, sprue_material: e.target.value })}
                                        disabled={formData.sprue_master == 1 ? false : true}
                                    ><option>Select the option</option>
                                        {[...new Map(
                                            optionJobs
                                                .filter(option => option.optjc_ID === 7)
                                                .map(option => [option.name, option])
                                        ).values()].map(uniqueOption => (
                                            <option value={uniqueOption.optjv_ID}>
                                                {uniqueOption.name}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">Metal</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="optjc_id"
                                        value={formData.sprue_feed}
                                        onChange={(e) => setFormData({ ...formData, sprue_feed: e.target.value })}
                                        disabled={formData.sprue_master == 1 ? false : true}
                                    ><option>Select the option</option>
                                        {[...new Map(
                                            optionJobs
                                                .filter(option => option.optjc_ID === 8)
                                                .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate
                                        ).values()].map(uniqueOption => (
                                            <option value={uniqueOption.optjv_ID}>
                                                {uniqueOption.name}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>

                        </div>
                        <div className="row">


                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">Post</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="optjc_id"
                                        value={formData.post}
                                        onChange={(e) => setFormData({ ...formData, post: e.target.value })}
                                    ><option>Select the option</option>
                                        {[...new Map(
                                            optionJobs
                                                .filter(option => option.optjc_ID === 9)
                                                .map(option => [option.name, option]) //USA `Name` as a key to avoid duplicate
                                        ).values()].map(uniqueOption => (
                                            <option value={uniqueOption.optjv_ID}>
                                                {uniqueOption.name}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="optjc_id" className="form-label">Status</label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="optjc_id"
                                        value={formData.est_id}
                                        onChange={(e) => setFormData({ ...formData, est_id: e.target.value })}
                                    ><option>Select the option</option>
                                        {statusJob.map(status => (
                                            <option value={status.est_ID}>
                                                {status.name}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>

                        </div>
                        <h5 style={{ paddingBlock: "9px" }}>Other Information</h5>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="user_transaction" className="form-label">Date Created</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="user_transaction"
                                    value={vAdminformat.FormatDate(formData.date_created)}
                                    name="user_transaction"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="user_transaction" className="form-label">User Created</label>
                                <input
                                    type="text"
                                    className="form-control"

                                    id="user_transaction"
                                    value={formData.user_created}
                                    name="user_transaction"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="user_transaction" className="form-label">Date Modified</label>
                                <input
                                    type="text"
                                    className="form-control"

                                    id="user_transaction"
                                    value={formData.date_modify && vAdminformat.FormatDate(formData.date_modify)}
                                    name="user_transaction"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label htmlFor="user_transaction" className="form-label">User Modified</label>
                                <input
                                    type="text"
                                    className="form-control"

                                    id="user_transaction"
                                    value={formData.user_modify}
                                    name="user_transaction"
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="hstack gap-2 justify-content-end d-print-none ">

                            <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Alert',
                                    text: "Are you sure you want to discard these changes?",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept',
                                    cancelButtonText: "Cancel"
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        CloseViewJob();
                                    }
                                }
                                )
                            }
                            }>Discard Change</Link>

                            <button type="button" className="btn btn-primary" onClick={handleUpdate}><i className="ri-save-line align-bottom me-1"></i> Save</button>
                        </div>
                    </div>
                </form>
            </div>

            <div
                className={`modal fade ${AddFiles ? "show" : ""}`}
                style={{ display: AddFiles ? "block" : "none", backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <center>
                                <h5 className="modal-title" id="myExtraLargeModalLabel">Select a file from the order</h5>
                            </center>
                            <Link className="btn-close" onClick={() => setAddFiles(false)} aria-label="Close"></Link>
                        </div>
                        <div className="modal-body" style={{ minHeight: "80vh" }}>
                            <div className="row g-4">
                                {/*Card izquierda: STL Viewer */}
                                <div className="col-6">
                                    <div className="card h-100">
                                        <div className="card-header">
                                            <h6 className="card-title mb-0">STL Viewer</h6>
                                        </div>
                                        <div
                                            className="d-flex justify-content-center align-items-center"
                                            style={{ height: '40vh', overflow: 'hidden' }}
                                        >
                                            <div style={{ width: '100%', height: '100%' }}>
                                                {temporalyFile && (
                                                    <STLViewerQuot url={`${server_backend}/${temporalyFile.files_path_file}`} currentColor={"selectedMaterialColor"} mystl={true} />
                                                )}
                                            </div>

                                        </div>

                                    </div>

                                </div>


                                <div className="col-6">
                                    <div className="card h-100">
                                        <div className="card-header">
                                            <h6 className="card-title mb-0">Select a File</h6>
                                        </div>
                                        <div className="card-body d-flex flex-column justify-content-between">
                                            <div className="mb-3" style={{ flexGrow: 1 }}>
                                                <div
                                                    style={{
                                                        maxHeight: '250px',
                                                        overflowY: 'auto',
                                                        padding: '15px',
                                                        backgroundColor: '#fff',
                                                    }}
                                                >
                                                    {selectedOrder && selectedOrder.jobs.length > 0 ? (
                                                        selectedOrder.jobs.map((OptionJ, index) => (
                                                            <button
                                                                key={`${OptionJ.ordj_ID}-${index}`} //generates a unique key
                                                                type="button"
                                                                className={`d-flex text-start align-items-center justify-content-between w-100 mb-2 ${temporalyFile?.ordj_ID === OptionJ.ordj_ID ? 'bg-primary text-white shadow-sm' : ''
                                                                    }`}
                                                                style={{
                                                                    borderRadius: '6px',
                                                                    border: '0px solid #dcdcdc',
                                                                    backgroundColor: temporalyFile?.ordj_ID === OptionJ.ordj_ID ? '#007bff' : '#fff',
                                                                    color: temporalyFile?.ordj_ID === OptionJ.ordj_ID ? '#fff' : '#333',
                                                                    cursor: 'pointer',
                                                                    transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                                                                    padding: '15px 20px',
                                                                    height: '60px',
                                                                }}
                                                                onClick={() => {
                                                                    setTemporalyFile(OptionJ);
                                                                }}
                                                            >
                                                                <div className="col-1 text-center">
                                                                    <input
                                                                        type="radio"
                                                                        name="ordj_id"
                                                                        checked={temporalyFile?.ordj_ID === OptionJ.ordj_ID}
                                                                        onChange={() => {
                                                                            setTemporalyFile(OptionJ);
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="col-11">
                                                                    <span>{OptionJ.files_name}</span>
                                                                </div>
                                                            </button>
                                                        ))
                                                    ) : (
                                                        <div className="text-center">No files available</div>
                                                    )}
                                                </div>
                                            </div>

                                            {!isUploading ? (
                                                <div className="mt-3" style={{ padding: '15px' }}>
                                                    <label
                                                        htmlFor="fileUpload"
                                                        className="d-flex justify-content-center align-items-center w-100"
                                                        onClick={() => openModalFile()}
                                                        style={{
                                                            height: '60px',
                                                            borderRadius: '6px',
                                                            border: '1px dashed #dcdcdc',
                                                            cursor: 'pointer',
                                                            color: '#007bff',
                                                            fontWeight: 'bold',
                                                            textAlign: 'center',
                                                            transition: 'background-color 0.3s ease, color 0.3s ease',
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#f8f9fa';
                                                            e.currentTarget.style.color = '#0056b3';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.backgroundColor = '#fff';
                                                            e.currentTarget.style.color = '#007bff';
                                                        }}
                                                    >
                                                        <i className="ri-upload-2-line me-2"></i> Click here if you want to select a file
                                                    </label>
                                                    <span
                                                        id="fileUpload"
                                                        style={{ display: 'none' }}

                                                    />
                                                </div>
                                            ) : (
                                                <div className="progress mt-3">
                                                    <div
                                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                                        role="progressbar"
                                                        aria-valuenow={uploadProgress}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                        style={{ width: `${uploadProgress}%` }}
                                                    >
                                                        {uploadProgress}%
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>



                            </div>

                            {/*Foot buttons */}
                            <div className="d-flex justify-content-end mt-4">
                                <Link type="button" className="btn btn-danger me-2" onClick={() => setAddFiles(false)}>
                                    Discard
                                </Link>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        selectFiles()
                                        setAddFiles(false);
                                    }}
                                >
                                    Select
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className={`modal fade ${fileUploadList ? 'show' : ''}`} style={{ display: fileUploadList ? 'block' : 'none', backgroundColor: "#0000007a" }} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="myExtraLargeModalLabel">{isUpdateJob === 1 ? "Update Job" : "Create Job"}</h5>
                            <button type="button" className="btn-close" onClick={closeModalFile} aria-label="Close"></button>
                        </div>
                        <div className="modal-body" style={{ minHeight: "80vh" }}>
                            <div id="paymentAccordion">
                                {isUpdateJob === 0 && (
                                    <div className="row">
                                        <div className="col-lg-4 col-sm-6">
                                            <div className="form-check card-radio">
                                                <input
                                                    id="paymentMethod01"
                                                    name="paymentMethod"
                                                    type="radio"
                                                    className="form-check-input"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#paymentmethodCollapseCustomerFile"
                                                    aria-expanded="false"
                                                    aria-controls="paymentmethodCollapseCustomerFile"
                                                    onClick={() => {
                                                        setSTLFileBussiness(null);
                                                        setConfUpload(false);
                                                        setIsPrivate(0)
                                                        setSelectedFiles([]);
                                                        setFormData({
                                                            ...formData,
                                                            volume: "",
                                                            area: "",
                                                            weight: "",
                                                            file_id: "",
                                                            dimensions: ""
                                                        });
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="paymentMethod01">
                                                    <span className="fs-16 text-muted me-2"><i className="ri-user-fill"></i></span>
                                                    <span className="fs-15 text-wrap"> All Files</span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="form-check card-radio">
                                                <input
                                                    id="paymentMethod02"
                                                    name="paymentMethod"
                                                    type="radio"
                                                    className="form-check-input"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#paymentmethodCollapseMyLibrary"
                                                    aria-expanded="false"
                                                    aria-controls="paymentmethodCollapseMyLibrary"
                                                    onClick={() => {
                                                        setSTLFileBussiness(null);
                                                        setConfUpload(false);
                                                        setSelectedFiles([]);
                                                        setIsPrivate(1);
                                                        setFormData({
                                                            ...formData,
                                                            volume: "",
                                                            area: "",
                                                            weight: "",
                                                            file_id: "",
                                                            dimensions: ""
                                                        });
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="paymentMethod02">
                                                    <span className="fs-16 text-muted me-2"><i className="ri-user-fill"></i></span>
                                                    <span className="fs-15 text-wrap">Print Folder</span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="form-check card-radio">
                                                <input
                                                    id="paymentMethod03"
                                                    name="paymentMethod"
                                                    type="radio"
                                                    className="form-check-input"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#paymentmethodCollapseUploadFile"
                                                    aria-expanded="false"
                                                    aria-controls="paymentmethodCollapseUploadFile"
                                                    onClick={() => {
                                                        setSTLFileBussiness(null);
                                                        setConfUpload(false);
                                                        setSelectedFiles([]);
                                                        setFormData({
                                                            ...formData,
                                                            volume: "",
                                                            area: "",
                                                            weight: "",
                                                            file_id: "",
                                                            dimensions: ""
                                                        });
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="paymentMethod03">
                                                    <span className="fs-16 text-muted me-2"><i className="ri-upload-2-line"></i></span>
                                                    <span className="fs-15 text-wrap">Upload File</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="collapse show" id="paymentmethodCollapseCustomerFile" data-bs-parent="#paymentAccordion">
                                    <div style={{ marginBlock: "1em" }}>
                                        {isUpdateJob === 0 ? (
                                            <div className="mb-3">
                                                <label htmlFor="select-existing-customer" className="form-label">My Library</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="select-existing-customer"
                                                    placeholder="Select or search for a File..."
                                                    onFocus={() => setIsDropdownVisible(true)}
                                                />

                                                {isDropdownVisible && (
                                                    <div className="dropdown-menu show w-100" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                        {customerFiles && customerFiles.length > 0 ? (
                                                            customerFiles.map((CustomerFile) => (
                                                                <button className="dropdown-item" type="button" key={CustomerFile.id || CustomerFile.name} onClick={() => {
                                                                    handleFileSelect(CustomerFile);
                                                                    setFileURL(`${server_backend}/${CustomerFile.path_file}`)
                                                                }
                                                                }>
                                                                    {CustomerFile.name}
                                                                </button>
                                                            ))
                                                        ) : (
                                                            <button className="dropdown-item" type="button" disabled>
                                                                No File found
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        ) : null}

                                        <div className="row">

                                            <div className="col-lg-6 col-md-12">
                                                <div className="row">


                                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                                        <div className="mt-3">
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Selected File: {STLfileBussiness.name}</p>
                                                            <div>
                                                                <STLViewerQuot url={fileURL} currentColor={selectedMaterialColor} onStatsUpdate={handleStatsUpdate} data={formData} currentDencity={currentDencity} />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <div className="row mt-3">
                                                                    {/*Estimated Completion Date Field */}
                                                                    <div className="col-6 d-flex flex-column">
                                                                        <label htmlFor="estimatedCompletionInput" className="form-label">Estimated Completion Date</label>
                                                                        <input
                                                                            type="date"
                                                                            className="form-control text-center"
                                                                            id="estimatedCompletionInput"

                                                                            onChange={(e) => setFormData({ ...formData, date_estimated: e.target.value })}
                                                                        />
                                                                    </div>

                                                                    {/*Parts Field */}
                                                                    <div className="col-6 d-flex flex-column">
                                                                        <label htmlFor="partsInput" className="form-label">Parts</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control text-center"
                                                                            id="partsInput"
                                                                            value={formData.parts ? formData.parts : 1}
                                                                            onChange={(e) => setFormData({ ...formData, parts: e.target.value })}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}


                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12">
                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <center>
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Model Stats:</p>
                                                        </center>
                                                        <div className="table-responsive" style={{ width: '100%', height: '40vh', overflow: "hidden" }}>
                                                            <table className="table table-bordered" style={{ width: '100%', height: '100%' }}>
                                                                <tbody>
                                                                    {/*<tr>
                                                                        <td className="font-weight-bold"><h6>Volume:</h6></td>
                                                                        <td className="text-end">
                                                                            <input
                                                                                type="text"
className="form-control text-center small-input"
                                                                                id="priceInput"
                                                                                value={formData.volume}
                                                                                onChange={(e) => {
SetForData ({... FormData, Volume: E.Target.Value});
                                                                                }}
                                                                            />
                                                                        </d>
                                                                    </rr>
<tr>
                                                                        <td className="font-weight-bold"><h6>Area:</h6></td>
                                                                        <td className="text-end">
                                                                            <input
                                                                                type="text"
className="form-control text-center small-input"
                                                                                id="priceInput"
                                                                                value={formData.area}
                                                                                onChange={(e) => {
SetForData ({... FormData, Area: E.Target.Value});
                                                                                }}
                                                                            />
                                                                        </d>
                                                                    </r> */}
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Weight:</h6></td>
                                                                        <td className="text-end" style={{ width: "20%" }}>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center small-input"
                                                                                id="priceInput"
                                                                                value={formData.weight}
                                                                                onChange={(e) => {
                                                                                    setFormData({ ...formData, weight: e.target.value });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Dimension:</h6></td>
                                                                        <td className="text-end">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control text-center small-input"
                                                                                id="priceInput"
                                                                                value={formData.dimensions}
                                                                                onChange={(e) => {
                                                                                    setFormData({ ...formData, dimensions: e.target.value });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>

                                                            </table>
                                                        </div>
                                                    </div>
                                                )}

                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <center>
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Material</p>
                                                        </center>
                                                        <div
                                                            style={{
                                                                minHeight: '26vh',
                                                                height: '26vh',
                                                                border: '1px solid #dcdcdc',
                                                                padding: "20px",
                                                                width: "100%",
                                                                backgroundColor: "#fff",
                                                                overflowY: 'auto',
                                                            }}
                                                        >
                                                            {materialList && materialList.length > 0 ? (
                                                                materialList.map((material) => (
                                                                    <button
                                                                        key={material.mat_ID}
                                                                        className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                                        type="button"
                                                                        onClick={() => {
                                                                            const vw = formData.weight * material.density;
                                                                            handleMaterialSelect(material);
                                                                            setSelectedMaterialColor(material.color);
                                                                            setCurrentDencity(material.density);


                                                                        }}
                                                                    >
                                                                        <div className="d-flex align-items-center">
                                                                            <ColorBox color={material.color} />
                                                                            <span className="ms-2">{material.name}</span>
                                                                        </div>
                                                                    </button>
                                                                ))
                                                            ) : (
                                                                <button className="dropdown-item" type="button" disabled>
                                                                    No materials found
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="collapse" id="paymentmethodCollapseMyLibrary" data-bs-parent="#paymentAccordion">
                                    <div style={{ marginBlock: "1em" }}>
                                        <div className="mb-3">
                                            <label htmlFor="select-existing-customer" className="form-label">
                                                Print Folder
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="select-existing-customer"
                                                placeholder="Select or search for a File..."
                                                onFocus={() => setIsDropdownVisible(true)}
                                                onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)} //Hide when losing focus
                                                onChange={(e) => setSearchTerm(e.target.value)} //Update the search term
                                                value={searchTerm}
                                            />

                                            {isDropdownVisible && (
                                                <div className="dropdown-menu show w-100" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                    {filteredFiles.length > 0 ? (
                                                        filteredFiles.map((bussinessFile) => (
                                                            <button
                                                                className="dropdown-item"
                                                                type="button"
                                                                key={bussinessFile.id || bussinessFile.name}
                                                                onClick={() => {
                                                                    handleFileSelect(bussinessFile);
                                                                    setSearchTerm(bussinessFile.name); //Update Input with the selected file

                                                                    setFileURL(`${server_backend}/${bussinessFile.path_file}`)
                                                                    setIsDropdownVisible(false); //Hide list
                                                                }}
                                                            >
                                                                {bussinessFile.name}
                                                            </button>
                                                        ))
                                                    ) : (
                                                        <button className="dropdown-item" type="button" disabled>
                                                            No File found
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="row">

                                            <div className="col-lg-6 col-md-12">
                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Selected File: {STLfileBussiness.name}</p>
                                                        <div>
                                                            <STLViewerQuot url={fileURL} currentColor={selectedMaterialColor} onStatsUpdate={handleStatsUpdate} data={formData} currentDencity={currentDencity} />
                                                        </div>
                                                        <div className="col-12 mb-3">
                                                            <div className="row mt-3">
                                                                {/*Estimated Completion Date Field */}
                                                                <div className="col-6 d-flex flex-column">
                                                                    <label htmlFor="estimatedCompletionInput" className="form-label">Estimated Completion Date</label>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control text-center"
                                                                        id="estimatedCompletionInput"

                                                                        onChange={(e) => setFormData({ ...formData, date_estimated: e.target.value })}
                                                                    />
                                                                </div>


                                                                {/*Parts Field */}
                                                                {/*  <div className="col-6 d-flex flex-column">
                                                                    <label htmlFor="partsInput" className="form-label">Parts</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control text-center"
ID = "PARTSINPUT"
                                                                        value = {formdata.parts? formdata.parts: 1}
                                                                        oncange = {(e) => setformdata ({... formdata, parts: e.target.value})}
                                                                    />
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <center>
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Material</p>
                                                        </center>
                                                        <div
                                                            style={{
                                                                minHeight: '23vh',
                                                                height: '22vh',
                                                                border: '1px solid #dcdcdc',
                                                                padding: "20px",
                                                                width: "100%",
                                                                backgroundColor: "#fff",
                                                                overflowY: 'auto',
                                                            }}
                                                        >
                                                            {materialList && materialList.length > 0 ? (
                                                                materialList.map((material) => (
                                                                    <button
                                                                        key={material.mat_ID}
                                                                        className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                                        type="button"
                                                                        onClick={() => {

                                                                            handleMaterialSelect(material);
                                                                            setSelectedMaterialColor(material.color);
                                                                            setCurrentDencity(material.density);


                                                                        }}
                                                                    >
                                                                        <div className="d-flex align-items-center">
                                                                            <ColorBox color={material.color} />
                                                                            <span className="ms-2">{material.name}</span>
                                                                        </div>
                                                                    </button>
                                                                ))
                                                            ) : (
                                                                <button className="dropdown-item" type="button" disabled>
                                                                    No materials found
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <center>
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Model Stats:</p>
                                                        </center>
                                                        <div className="table-responsive" style={{ width: '100%', height: '42vh', overflow: "hidden" }}>
                                                            <table className="table table-bordered" style={{ height: '23vh' }}>
                                                                <tbody>
                                                                    {/*<tr>
                                                                        <td className="font-weight-bold"><h6>Volume:</h6></td>
                                                                        <td className="text-end">
                                                                            <input
                                                                                type="text"
className="form-control text-center small-input"
                                                                                id="priceInput"
                                                                                value={formData.volume}
                                                                                onChange={(e) => {
SetForData ({... FormData, Volume: E.Target.Value});
                                                                                }}
                                                                            />
                                                                        </d>
                                                                    </rr>
<tr>
                                                                        <td className="font-weight-bold"><h6>Area:</h6></td>
                                                                        <td className="text-end">
                                                                            <input
                                                                                type="text"
className="form-control text-center small-input"
                                                                                id="priceInput"
                                                                                value={formData.area}
                                                                                onChange={(e) => {
SetForData ({... FormData, Area: E.Target.Value});
                                                                                }}
                                                                            />
                                                                        </d>
                                                                    </r> */}
                                                                    <tr>
                                                                        <td className="font-weight-bold">
                                                                            <h6>Weight (g):</h6>
                                                                        </td>
                                                                        <td className="text-end" style={{ width: "20%" }}>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center small-input"
                                                                                id="weightInput"
                                                                                placeholder="Enter weight in grams"
                                                                                value={formData.weight}
                                                                                onChange={(e) => {
                                                                                    setFormData({ ...formData, weight: e.target.value });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="font-weight-bold">
                                                                            <h6>Dimensions (mm):</h6>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control text-center small-input"
                                                                                id="dimensionsInput"
                                                                                placeholder="Enter dimensions in mm"
                                                                                value={formData.dimensions}
                                                                                onChange={(e) => {
                                                                                    setFormData({ ...formData, dimensions: e.target.value });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>

                                                                </tbody>

                                                            </table>
                                                        </div>
                                                    </div>
                                                )}


                                            </div>

                                        </div>


                                    </div>
                                </div>

                                <div className="collapse" id="paymentmethodCollapseUploadFile" data-bs-parent="#paymentAccordion">

                                    {ConfUpload ? (
                                        <div class="alert alert-success alert-dismissible fade show" style={{ marginBlock: "2em" }} role="alert">
                                            <strong>The file has been successfully uploaded!</strong> You can locate it in the 'Print Folder' under the name <strong>{AliasFileName}</strong>.
                                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                        </div>

                                    ) : (
                                        <div style={{ marginBlock: "2em" }}>
                                            <div >
                                                <label htmlFor="formFile" className="form-label">Upload Your File</label>
                                                <input className="form-control" type="file" id="formFile" accept=".stl" onChange={handleFileChange} />
                                            </div>

                                            {selectedFiles.length > 0 && (
                                                <div className="mt-3">
                                                    <h6>Selected Files:</h6>
                                                    <ul className="list-group">
                                                        {selectedFiles.map((file, index) => (
                                                            <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                                {file.name}
                                                                <span className="badge bg-primary rounded-pill">{Math.round(file.size / 1024)} KB</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}

                                            {isUploading && (
                                                <div className="progress mt-3">
                                                    <div
                                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                                        role="progressbar"
                                                        aria-valuenow={uploadProgress}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                        style={{ width: `${uploadProgress}%` }}
                                                    >
                                                        {uploadProgress}%
                                                    </div>
                                                </div>
                                            )}

                                            <div className="mt-3">
                                                <button className="btn btn-primary w-100" onClick={handleUploadFileModal} disabled={isUploading}>
                                                    {isUploading ? 'Uploading...' : 'Upload and Save'}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {(STLfileBussiness && STLfileBussiness.name) && (
                                    <div className="row">
                                        {/*Quantity Field */}
                                        <div className="col-3 d-flex flex-column">
                                            <label htmlFor="quantityInput" className="form-label">Quantity</label>
                                            <div className="input-step d-flex align-items-center w-100">
                                                <button type="button" className="minus" onClick={() => handleDecreaseQuantity()}>–</button>
                                                <input
                                                    type="number"
                                                    className="text-center mx-2 product-quantity w-100"
                                                    value={jobQty ? jobQty : 1}
                                                    min="0"
                                                    max="100"
                                                    readOnly
                                                />
                                                <button type="button" className="plus btn btn-light" onClick={() => handleIncreaseQuantity()}>+</button>
                                            </div>
                                        </div>

                                        {/*Price Field */}
                                        <div className="col-3 d-flex flex-column">
                                            <label htmlFor="priceInput" className="form-label">Price</label>

                                            <input type="number" class="form-control" value={currentPrice} required
                                                onChange={handlePriceChange} />
                                        </div>

                                        {/* Discount */}

                                        <div className="col-3 d-flex flex-column">
                                            <label htmlFor="priceInput" className="form-label">Discount</label>
                                            <div className="input-group">
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    id="cart-discount"

                                                    onKeyUp={(e) => {

                                                        let value = 0;
                                                        if (e.target.value == '') {
                                                            value = 0;
                                                            e.target.value = 0;
                                                            setFormData({ ...formData, discount: value });
                                                        } else {
                                                            e.target.value = parseInt(e.target.value);
                                                            setFormData({ ...formData, discount: parseInt(e.target.value) });
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/*Total Field */}
                                        <div className="col-3 d-flex flex-column">
                                            <label htmlFor="totalInput" className="form-label">Total</label>
                                            <input
                                                type="text"
                                                className="form-control text-center"
                                                id="totalInput"
                                                value={vAdminformat.FormatMoney(
                                                    (currentPrice * jobQty) - (formData.discount || 0)
                                                )}
                                                readOnly
                                                disabled
                                            />
                                        </div>
                                    </div>
                                )}

                                {(STLfileBussiness && STLfileBussiness.name) && (
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label htmlFor="jobComment">Comments:</label>
                                                <textarea
                                                    id="jobComment"
                                                    className="form-control"
                                                    value={formData.job_comment}
                                                    onChange={(e) => setFormData({ ...formData, job_comment: e.target.value })}
                                                    placeholder="Add your comments here"
                                                    rows="5"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {(STLfileBussiness && STLfileBussiness.name) && (
                                    <div className="col-12">
                                        <div className="card border-light shadow-sm mb-3" style={{ marginBlock: "10px", border: '1px solid #dcdcdc' }}>
                                            <div className="card-body d-flex justify-content-end align-items-center flex-wrap">

                                                <button
                                                    className="btn btn-primary w-25"
                                                    onClick={createJobs}
                                                >
                                                    Save
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}


export default JobLiveUpdate